<template>
  <div class="admin-container">
    <h1>관리자 페이지 - 사용자 관리</h1>

    <button
      @click="openAddModal"
      class="mb-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition mr-2"
    >
      사용자 추가
    </button>
    <button
      @click="$emit('go-back')"
      class="mb-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
    >
      뒤로가기
    </button>

    <table class="admin-table">
      <thead>
        <tr>
          <th>아이디</th>
          <!--
          <th>비밀번호</th>
          -->
          <th>닉네임</th>
          <th class="grade-header">등급</th>
          <th style="text-align:center;">삭제</th>
          <th style="text-align:center;">수정</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.username">
          <td>{{ user.username }}</td>
          <!--
          <td>{{ user.password }}</td>
          -->
          <td>{{ user.nickname }}</td>
          <td>{{ user.grade }}</td>
          <!--
            <td>
              <select v-model="user.grade" @change="updateGrade(user)">
                <option value="normal">normal</option>
                <option value="admin">admin</option>
              </select>
            </td>
          -->
          <td style="text-align:center;">
            <button class="btn-delete" @click="deleteUser(user.username)">삭제</button>
          </td>
          <td style="text-align:center;">
            <button class="btn-edit" @click="editUser(user)">수정</button>
          </td>
        </tr>
      </tbody>
    </table>


    <!-- 추가/수정 모달 -->
    <div v-if="showModal" class="add-modal-backdrop">
      <div class="add-modal">
        <h2>{{ mode === 'add' ? '사용자 추가' : '사용자 수정' }}</h2>
        <input v-model="newUser.username" type="text" placeholder="아이디" />
        <input v-model="newUser.password" type="password" placeholder="비밀번호 (수정 시 변경할 경우만 입력)" />
        <input v-model="newUser.nickname" type="text" placeholder="닉네임" />
        <select v-model="newUser.grade">
          <option value="normal">normal</option>
          <option value="admin">admin</option>
        </select>
        <div class="add-modal-buttons">
          <button class="btn-cancel" @click="closeModal">취소</button>
          <button class="btn-add" v-if="mode==='add'" @click="addUser">추가</button>
          <button class="btn-add" v-else @click="updateUser">수정</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      showModal: false,
      mode: 'add', // 'add' 또는 'edit'
      newUser: {
        username: '',
        password: '',
        grade: 'normal',
        nickname: '',
      },
      originalUsername: '',
    };
  },
  created() {
    this.fetchUsers();
  },
  methods: {
    async fetchUsers() {
      try {
        const res = await fetch('https://s.stni.co.kr/login.php?action=list');
        const data = await res.json();
        if (data.success) {
          this.users = data.users;
        } else {
          alert('사용자 목록을 불러오는데 실패했습니다.');
        }
      } catch {
        alert('서버 오류');
      }
    },
    async deleteUser(username) {
      if (!confirm(`${username} 사용자를 삭제하시겠습니까?`)) return;

      try {
        const res = await fetch('https://s.stni.co.kr/login.php?action=delete', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username }),
        });
        const data = await res.json();
        if (data.success) {
          alert('삭제 완료');
          this.fetchUsers();
        } else {
          alert('삭제 실패: ' + data.message);
        }
      } catch {
        alert('서버 오류');
      }
    },
    async addUser() {
      if (
        !this.newUser.username ||
        !this.newUser.password ||
        !this.newUser.nickname
      ) {
        alert('모든 항목을 입력해주세요');
        return;
      }

      try {
        const res = await fetch('https://s.stni.co.kr/login.php?action=add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.newUser),
        });
        const data = await res.json();
        if (data.success) {
          alert('추가 완료');
                  
          this.newUser.username = '';
          this.newUser.password = '';
          this.newUser.grade = 'normal';
          this.newUser.nickname = '';
          this.fetchUsers();
          this.showModal = false;
        } else {
          alert('추가 실패: ' + data.message);
        }
      } catch {
        alert('서버 오류');
      }
    },
    updateUser() {
      if (!this.newUser.username) {
        alert('아이디가 없습니다.');
        return;
      }

      const payload = {
        originalUsername: this.originalUsername, // 원래 아이디
        username: this.newUser.username,         // 변경된 아이디
        password: this.newUser.password,
        grade: this.newUser.grade,
        nickname: this.newUser.nickname,
      };

      fetch('https://s.stni.co.kr/login.php?action=updateUser', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            alert('수정 완료');
            this.closeModal();
            this.fetchUsers();
          } else {
            alert('수정 실패: ' + data.message);
          }
        })
        .catch(() => alert('서버 오류'));
    },

    editUser(user) {
      this.mode = 'edit';
      // 기존 newUser 객체의 속성만 변경 (reactivity 유지됨)
      this.originalUsername = user.username;  
      this.newUser.username = user.username;
      this.newUser.password = ''; // 비밀번호는 비워둠
      this.newUser.grade = user.grade;
      this.newUser.nickname = user.nickname;
      this.showModal = true;
    },
    openAddModal() {
      this.mode = 'add';
      this.newUser.username = '';
      this.newUser.password = '';
      this.newUser.grade = 'normal';
      this.newUser.nickname = '';
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
/* 기존 로그인 스타일 유지 */
.logo {
  width: 100%;
  height: 100%;
  vertical-align: middle;
  margin-bottom: 30px;
}
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #1e1e2f;
}
.login-box {
  background: #2c3e50;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  width: 300px;
  text-align: center;
  color: white;
}
.login-box h2 {
  margin-bottom: 20px;
  color: white;
}
.login-box input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #555;
  border-radius: 6px;
  font-size: 16px;
  background-color: #3b3b4f;
  color: white;
}
.login-box input::placeholder {
  color: #ccc;
}
.login-box button {
  width: 100%;
  padding: 10px;
  background-color: #3498db;
  color: white;
  border: none;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.login-box button:hover {
  background-color: #2980b9;
}
.error {
  margin-top: 10px;
  color: #ff6b6b;
  font-size: 14px;
}

/* 관리자 페이지 테이블 스타일 - 로그인 테마에 맞춤 */
.admin-container {
  min-height: 100vh;
  padding: 40px 20px;
  background: #38238b;
  color: white;
  font-family: 'Noto Sans KR', sans-serif;
}
.admin-container h1 {
  text-align: center;
  margin-bottom: 30px;
  font-weight: 700;
}
.admin-table {
  width: 100%;
  border-collapse: collapse;
  background: #2c3e50;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0,0,0,0.3);
}
.admin-table thead {
  background: #3b4a69;
}
.admin-table thead th.grade-header {
  text-align: left;     /* 좌측 정렬 */
  padding-left: 20px;   /* 왼쪽 여백 조절 */
  padding-right: 15px;  /* 오른쪽 여백 필요 시 */
}
.admin-table th,
.admin-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #4a5a7a;
  vertical-align: middle;
}
.admin-table th {
  font-weight: 600;
  color: #d1d9ff;
}
.admin-table tbody tr:hover {
  background-color: #4a5a7a;
}
.admin-table td select {
  background: #3b3b4f;
  color: white;
  border: 1px solid #555;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 14px;
  cursor: pointer;
}

/* 삭제 버튼 스타일 - 로그인 버튼과 비슷하게 */
.btn-delete {
  background-color: #e74c3c;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.3s;
}
.btn-delete:hover {
  background-color: #c0392b;
}

.btn-edit {
  background-color: #372fb0;
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.3s;
}
.btn-edit:hover {
  background-color: #181460;
}

/* 사용자 추가 모달 스타일 */
.add-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.add-modal {
  background: #2c3e50;
  padding: 30px 25px;
  border-radius: 10px;
  width: 360px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.5);
  color: white;
  font-size: 16px;
}
.add-modal h2 {
  margin-bottom: 20px;
  font-weight: 700;
  text-align: center;
}
.add-modal input,
.add-modal select {
  width: 100%;
  padding: 10px;
  margin: 10px 0 15px 0;
  border-radius: 6px;
  border: 1px solid #555;
  background-color: #3b3b4f;
  color: white;
  font-size: 16px;
  box-sizing: border-box;
}
.add-modal input::placeholder {
  color: #ccc;
}
.add-modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.add-modal button {
  padding: 10px 18px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  font-size: 16px;
  transition: background-color 0.3s;
}
.add-modal .btn-cancel {
  background-color: transparent;
  border: 1px solid #555;
  color: #ccc;
}
.add-modal .btn-cancel:hover {
  background-color: #3b3b4f;
}
.add-modal .btn-add {
  background-color: #3498db;
  color: white;
}
.add-modal .btn-add:hover {
  background-color: #2980b9;
}
</style>
